import axiosReq from '@/app/interceptor'
import { useState, useEffect } from 'react'
import { toast } from 'react-toastify'
import useDismissAlert from './useDismissAlert'

const useResendOTP = (email: string) => {
  const [isResending, setIsResending] = useState<boolean>(false)
  const [resendTimer, setResendTimer] = useState<number>(0)
  const [resendError, setResendError] = useDismissAlert({ message: '' }, 5000)

  useEffect(() => {
    if (resendTimer > 0) {
      const timer = setTimeout(() => setResendTimer(resendTimer - 1), 1000)
      return () => clearTimeout(timer)
    }
  }, [resendTimer])

  const resendOTP = async () => {
    setIsResending(true)
    setResendError({ message: '' })

    try {
      const response = await axiosReq.post('/app/v2/auth/sign-up-resend-otp', {
        email
      })

      if (response.status === 200) {
        toast.success('Verification OTP resent! Please check your email.')
        setResendTimer(60) // Start countdown from 60 seconds
      } else {
        setResendError({
          message:
            response.data?.message || 'Failed to resend OTP. Please try again.'
        })
      }
    } catch (error: any) {
      const errorMsg =
        error.response?.data?.message ||
        'An error occurred while resending the OTP. Please try again.'
      setResendError({ message: errorMsg })
    } finally {
      setIsResending(false)
    }
  }

  return { isResending, resendTimer, resendOTP, resendError }
}

export default useResendOTP
